/**
 * P4-08: RightPanel —— 右栏根组件。
 *
 * 组合 P4-02~P4-07 产出的子组件：
 * - CalendarBlock（日历块）
 * - 标签头：Log / Queue（Queue 受 `getFeatureFlag("QUEUE")` 控制）
 * - LogPanel（日志列表 + 工具条 + filters）
 * - QueuePanel（队列面板）
 *
 * 保留旧 DOM id（`rightColumn`、`rightTabLog`、`rightTabQueue`、`logLink`、`queueLink`）
 * 以兼容旧 CSS 与外部脚本。
 */
import { useCallback, useState } from "react";
import { useGameTick } from "../../bridge/useGameTick";
import type { GamePage } from "../../bridge/GameBridge";
import { t } from "../../bridge/i18n";
import CalendarBlock from "./CalendarBlock";
import LogPanel from "./LogPanel";
import QueuePanel from "./QueuePanel";
import { TooltipProvider } from "../../components/Tooltip/TooltipProvider";

type RightTab = "log" | "queue";

function getQueueEnabled(game: GamePage | null): boolean {
  return !!game?.getFeatureFlag?.("QUEUE");
}

export default function RightPanel() {
  const queueEnabled = useGameTick(
    useCallback((game) => getQueueEnabled(game), []),
  );
  const [activeTab, setActiveTab] = useState<RightTab>("log");

  return (
    <TooltipProvider>
      <div id="rightColumn" className="column" aria-label="Game log">
        <CalendarBlock />
        <div className="right-tab-header">
          <a
            id="logLink"
            href="#"
            className={activeTab === "log" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab("log");
            }}
          >
            {t("ui.log.link")}
          </a>
          {queueEnabled && (
            <a
              id="queueLink"
              className={`queueLink ${activeTab === "queue" ? "active" : ""}`}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setActiveTab("queue");
              }}
            >
              {t("ui.queue.link")}
            </a>
          )}
        </div>
        <div id="observeButton" />
        <div
          className="right-tab"
          id="rightTabLog"
          style={{ display: activeTab === "log" ? "block" : "none" }}
        >
          <LogPanel />
        </div>
        <div
          className="right-tab"
          id="rightTabQueue"
          style={{ display: activeTab === "queue" ? "block" : "none" }}
        >
          <QueuePanel />
        </div>
      </div>
    </TooltipProvider>
  );
}
